import React from "react";
import EconoHeader from "./EconoHeader";
import Form from "../../common/Form/Form";
import "./style.css";

const EconoMain = () => {
  return (
    <div className="econo">
      <EconoHeader />
      <Form />
    </div>
  );
};

export default EconoMain;
